import { InjectionToken } from '@angular/core';

export interface IAppConfiguration {
  baseApiUrl: string;
  licenseUrl: string;
}

export const APP_CONFIG = new InjectionToken<IAppConfiguration>('app.config');
